import { ShopRendererApiClient } from '@fourthwall/services/dist/ShopRendererApiClient'
import { createMutationHook } from '@fourthwall/utils/dist/queries'

export const useRemoveTiktokIntegrationMutation = createMutationHook(
  ShopRendererApiClient.removeTiktokIntegration,
  {
    mutationKey: ['removeTiktokIntegration'],
  },
)
